const Admin = () => import(/* webpackChunkName: "proj" */ './Admin');
const Appl = () => import(/* webpackChunkName: "proj" */ './Appl');

export default {
  routes: [
    {
      path: '/proc/jc306/admin',
      name: 'proc_jc306_admin',
      component: Admin,
      meta:{public:true}
    },
    {
      path: '/proc/jc306/appl',
      name: 'proc_jc306_appl',
      component: Appl,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/proc/jc306/router.js